if (!Enum) {
    var Enum = {};
}

Enum.LABORATORY_TEST_RESULT_TYPE = {
    RTG: 'RTG',
    USG: 'USG',
    MRI: 'MRI',
    TK: 'TK',
    LABORATORY_TEST : 'LABORATORY_TEST',
    OTHER: 'OTHER'
};

Object.freeze(Enum.LABORATORY_TEST_RESULT_TYPE);